module.exports = __webpack_public_path__ + "img/8.d2c0b027.png";